import { createContext } from 'react';
import { AdminContextInterface } from '../interfaces/ApplicationInterfaces';

// export const AdminContext = createContext<AdminContextInterface>({ id: '', adminApplications: [], allApplications: {}, generalPermissions: { manageAdmins: false, createUsers: false, approveOrDeny: false}, getToken: async () => { return '' }, isOrganizationAdmin: false, isSuperAdmin: false, organizationId: '', roleSpecificPermissions: {}, organizationList: [] });
export const initAdminContext = (): AdminContextInterface => {
  return {
    id: '',
    adminApplications: [],
    allApplications: {},
    allGroups: {},
    generalPermissions: {
      manageAdmins: false,
      createUsers: false,
      approveOrDeny: false,
    },
    isOrganizationAdmin: false,
    isSuperAdmin: false,
    organizationId: '',
    roleSpecificPermissions: {},
    multiOrg: false,
    organizationList: [],
    roles: []
  };
};

export const AdminContext = createContext<{
  adminCredentials: AdminContextInterface;
  setAdminCredentials: React.Dispatch<
    React.SetStateAction<AdminContextInterface>
  >;
  getToken: () => Promise<string | undefined>;
  getTokenClaims: () => Promise<object | null | undefined>;
  uiLocale: string;
}>({
  adminCredentials: initAdminContext(),
  setAdminCredentials: () => true,
  getToken: async () => {
    return '';
  },
  getTokenClaims: async () => {
    return null;
  },
  uiLocale: ''
});
